import React, { useState } from 'react';

import Dropdown from 'components/dropdown';
import Modal from './modal';
import PropertyImportModal from 'bundles/crm/imports/properties';
import { Button } from 'components/ui/button';
import { retrieveRecords } from 'bundles/research/index/store/actions/search.js';
import { useDispatch } from 'bundles/research/index/store/hooks';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { DromoImporterProps } from 'components/dromo/types';
import type { Country } from 'bundles/crm/imports/types';

interface NewPropertyButtonProps {
  edgeCrm: boolean;
  importerProps: {
    countries: Country[];
    customFields: CustomField[];
    dromoImporterProps: DromoImporterProps;
  };
  insights: boolean;
  newPropertyPath: string;
}

export default function NewPropertyButton({
  edgeCrm,
  importerProps,
  insights,
  newPropertyPath,
}: NewPropertyButtonProps) {
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showImportsModal, setShowImportsModal] = useState<boolean>(false);

  if (!edgeCrm || !insights) {
    return <Button href={newPropertyPath} label="New Property" />;
  }

  const dispatch = useDispatch();
  const hideImportModal = (refresh) => {
    if (refresh) {
      dispatch(retrieveRecords());
    }
    setShowImportsModal(false);
  };

  return (
    <>
      <Dropdown
        label="New Property"
        variant="primary"
      >
        <Dropdown.Item label="New Property" onClick={() => setShowCreateModal(true)} />
        <Dropdown.Item label="Import Properties" onClick={() => setShowImportsModal(true)} />
      </Dropdown>
      <Modal
        newPropertyPath={newPropertyPath}
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
      />
      <PropertyImportModal
        {...importerProps}
        show={showImportsModal}
        onHide={hideImportModal}
      />
    </>
  );
}
